<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-15 13:47:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-30 16:29:59
--> 
<template>
  <div class="bigbox">
    <div>
      <span class="span2"
            :style="{color: $vuetify.theme.defaults.light.primary}"
            v-if="readonly"
            @click="addvariate">{{$t('label_Join_the_variables')}}
        <mrc_ess_svgIcon iconClass='open_in_new'></mrc_ess_svgIcon>
      </span>
    </div>
    <mrc_ess_myDialog v-model="dialog"
                      :title="$t('label_A_new_level')"
                      width='800'
                      hiddenTitle
                      :disabled='false'
                      @cancel='close'>
      <v-card-text>
        <v-tabs v-model="tab"
                grow
                background-color="#ffffff"
                color='primary'
                dark>
          <v-tab v-for="(item,index) in items"
                 style="color:black"
                 :key="index">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item style="overflow-y: scroll;max-height: 300px">
            <div v-for="(item,index) in variatelist"
                 :key="index+item">
              <div class="ptbox"
                   @click="changebgd(item,index)"
                   :class="item.divbgd?'divbgd':''">
                <span>{{item.property}}</span>
                <span style='color:#bcbcbc'>{{item.name}}</span>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item style="overflow-y: scroll;max-height: 300px">
            <div v-for="(item,index) in syslist"
                 :key="index+item">
              <div class="ptbox"
                   @click="changebgd2(item,index)"
                   :class="item.divbgd?'divbgd':''">
                <span>{{item.property}}</span>
                <span style='color:#bcbcbc'>{{item.name}}</span>
              </div>
            </div>
          </v-tab-item>

        </v-tabs-items>
      </v-card-text>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import { getBusinessList } from '@/service/api/prompt.js'
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: true
    },
    function_uuid: {
      type: String
    },
    // updateFunction_uuid: {
    //   type: String
    // },
  },
  data () {
    return {
      itemss: [
      ],
      offset: true,
      tab: null,
      items: [
        { tab: '功能变量' },
        { tab: '系统变量' },
      ],
      dialog: false,
      variatelist: [],
      syslist: []
    };
  },
  computed: {},
  created () { },
  watch: {
  },
  mounted () {
  },
  methods: {
    async getvariatelist () { //获取属性字段列表
      //发送请求)
      if (!this.variatelist.length > 0) {
        const res = await getBusinessList({
          prompt_name: 'email_address_field',
          uuid: this.function_uuid
        })
        if (res.code == 200) {
          this.variatelist = res.data.map(item => {
            item.property = '{{' + item.field_name + '}}'
            delete item.field_name
            return { ...item, divbgd: false }
          })
        }
      }
      // this.variatelist = this.variatelist.map(item => {
      //   return { ...item, divbgd: false }
      // })
    },
    async getsyslist () { //获取系统变量
      //发送请求)
      this.syslist = [ //系统变量
        {
          property: '{{112saaas}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112xasaokhhh}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112qqqws}}',
          name: 'xasxaxaxaxaaxa'
        },
        {
          property: '{{112qwertyui}}',
          name: 'xaxxsxaxxaaxa'
        },
        {
          property: '{{112saaas}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112xasaokhhh}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112qqqws}}',
          name: 'xasxaxaxaxaaxa'
        },
        {
          property: '{{112qwertyui}}',
          name: 'xaxxsxaxxaaxa'
        },
        {
          property: '{{112saaas}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112xasaokhhh}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112qqqws}}',
          name: 'xasxaxaxaxaaxa'
        },
        {
          property: '{{112qwertyui}}',
          name: 'xaxxsxaxxaaxa'
        },
        {
          property: '{{112saaas}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112xasaokhhh}}',
          name: 'xasxaxaaxa'
        },
        {
          property: '{{112qqqws}}',
          name: 'xasxaxaxaxaaxa'
        },
        {
          property: '{{112qwertyui}}',
          name: 'xaxxsxaxxaaxa'
        }
      ]
      this.syslist = this.syslist.map(item => {
        return { ...item, divbgd: false }
      })
    },
    async addvariate () {
      this.dialog = true
      await this.getvariatelist()
      await this.getsyslist()
    },
    changebgd (item, index) {
      item.divbgd = !item.divbgd
      this.$set(this.variatelist, index, item)
    },
    changebgd2 (item, index) {
      item.divbgd = !item.divbgd
      this.$set(this.syslist, index, item)
    },
    close () {
      this.dialog = false
      let newpropertylist = []
      let variatelist = []
      let syslist = []
      this.variatelist.map(item => {
        if (item.divbgd == true) {
          variatelist.push(item)
          newpropertylist.push(item)
        }
      })
      this.syslist.map(item => {
        if (item.divbgd == true) {
          syslist.push(item)
          newpropertylist.push(item)
        }
      })
      this.$emit('getpropertylist', variatelist)
      this.$emit('getsyslist', syslist)
      this.$emit('getalllist', newpropertylist)
      this.variatelist = this.variatelist.map(item => {
        return { ...item, divbgd: false }
      })
      this.syslist = this.syslist.map(item => {
        return { ...item, divbgd: false }
      })
    },
    save () {
      // this.$v.editedItem.$touch()
      // if (this.$v.editedItem.$error) return
      // this.close()
    },
  },
};
</script>

<style scoped>
.divbgd {
  background-color: #e5eeff;
}
.span2 {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
.span2 /deep/.svg-icon {
  font-size: 20px;
}
.ptbox {
  display: flex;
  flex-direction: column;
  height: 50px;
  border-bottom: 2px solid #eeeef0;
}
/* .bigbox /deep/.v-card__text {
  position: absolute;
  z-index: 12;
  top: -49px;
  left: -17px;
} */
</style>
